import styled from '@material-ui/core/styles/styled';
import Paper from '@material-ui/core/Paper';

export default styled(Paper)(({ intenseradius = false, newPadding = '20px 20px 20px 20px' }) => ({
  borderRadius: intenseradius ? '46px' : '7px',
  padding: newPadding,
}));
